<template>
  <MyManage>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane :label="$t('gu-zhang-fen-xi')" name="alarm" v-if="checkPermission(['bee:ops:statistic:alarmStatistic'])">
        <AlarmRecordStatistic v-if="activeName==='alarm'"></AlarmRecordStatistic>
      </el-tab-pane>
    </el-tabs>
  </MyManage>
</template>

<script>
  import MyManage from '@/components/MyManage'
  import AlarmRecordStatistic from '@/module/dataCenter/page/alarmAnalyse/alarmRecordStatistic.vue'

  export default {
    name: 'manage',
    components: {
      MyManage,
      AlarmRecordStatistic
    },
    data() {
      return {
        activeName: 'alarm',
      }
    },
    created() {
    },
    mounted() {
    },
    watch: {},
    methods: {
      handleClick(tab, event) {
      }
    }
  }
</script>

<style>
  .el-dialog__header {
    text-align: center;
  }

  #manage .el-switch.is-disabled .el-switch__core, #manage .el-switch.is-disabled .el-switch__label {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/alarmManager.vue